import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, switchMap } from 'rxjs';

import { ApiService } from 'ish-core/services/api/api.service';

import { SaveForLaterData } from '../../models/save-for-later/save-for-later.interface';
import { SaveForLaterMapper } from '../../models/save-for-later/save-for-later.mapper';
import {
  AddSaveForLaterType,
  MoveSaveForLaterType,
  SaveForLater,
  UpdateSaveForLaterType,
} from '../../models/save-for-later/save-for-later.model';

@Injectable({ providedIn: 'root' })
export class SaveForLaterService {
  constructor(private apiService: ApiService, private saveForLaterMapper: SaveForLaterMapper) {}

  getSaveForLaterProducts(): Observable<SaveForLater> {
    return this.apiService
      .get<SaveForLaterData>('saveforlaterlist')
      .pipe(map(saveForLaterData => this.saveForLaterMapper.fromData(saveForLaterData)));
  }

  moveItemToSaveForLater(payload: AddSaveForLaterType) {
    return this.apiService.post('saveforlaterlist', payload).pipe(switchMap(() => this.getSaveForLaterProducts()));
  }

  /** CUSTOMIZATION: add a catalog SKU directly to Saved for later (no basket line) — FR13.7.5. */
  addSkuToSaveForLater(sku: string, quantity: number) {
    return this.apiService
      .post('saveforlaterlist', {
        sku,
        quantity: Math.max(1, Math.floor(Number(quantity) || 1)),
      })
      .pipe(switchMap(() => this.getSaveForLaterProducts()));
  }

  updateItemFromSaveForLater(payload: UpdateSaveForLaterType) {
    return this.apiService.patch(`saveforlaterlist`, payload).pipe(switchMap(() => this.getSaveForLaterProducts()));
  }

  removeItemFromSaveForLater(wishlistLineItemId: string) {
    return this.apiService
      .delete('saveforlaterlist', {
        params: new HttpParams().set('wishlistLineItemId', wishlistLineItemId),
      })
      .pipe(switchMap(() => this.getSaveForLaterProducts()));
  }
  moveSaveForLaterItemToBasket(payload: MoveSaveForLaterType) {
    return this.apiService
      .post('saveforlaterlist/purchase', payload)
      .pipe(switchMap(() => this.getSaveForLaterProducts()));
  }
}
